import { isDnacprClinicallyActive } from '@lmc/validations/lib/utils/dnacpr'

/** True when a DNACPR order is in clinical effect (show DNACPR badge / do not attempt CPR). */
export const shouldDisplayDnacpr = (
  dnacpr?: boolean,
  dnacprStartDate?: string | null
) => isDnacprClinicallyActive(dnacpr, dnacprStartDate ?? undefined)
